import { observer } from 'mobx-react-lite';
import { ComponentProps, ReactElement } from 'react';

export const ChartBarIcon = observer(
  (props: ComponentProps<'svg'>): ReactElement => (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path d='M4.16675 8.91699C4.16675 8.22664 4.72639 7.66699 5.41675 7.66699V7.66699C6.1071 7.66699 6.66675 8.22664 6.66675 8.91699V15.5837C6.66675 15.7217 6.55482 15.8337 6.41675 15.8337H4.41675C4.27868 15.8337 4.16675 15.7217 4.16675 15.5837V8.91699ZM8.83341 5.33366C8.83341 4.68933 9.35575 4.16699 10.0001 4.16699V4.16699C10.6444 4.16699 11.1667 4.68933 11.1667 5.33366V15.5837C11.1667 15.7217 11.0548 15.8337 10.9167 15.8337H9.08341C8.94534 15.8337 8.83341 15.7217 8.83341 15.5837V5.33366ZM13.5001 12.0003C13.5001 11.356 14.0224 10.8337 14.6667 10.8337V10.8337C15.3111 10.8337 15.8334 11.356 15.8334 12.0003V15.5837C15.8334 15.7217 15.7215 15.8337 15.5834 15.8337H13.7501C13.612 15.8337 13.5001 15.7217 13.5001 15.5837V12.0003Z' />
    </svg>
  )
);
